export const leadRetentionFilter = [
  { id: 'NotSet', name: 'No Set' },
  { id: 'InRetention', name: 'Yes' },
  { id: 'NotInRetention', name: 'No' },
] as const;

export const prefix = '@promo-preview';

export const visible = [
  { id: true, name: 'Yes' },
  { id: false, name: 'No' },
] as const;

export const PROMO_FORM_NAME = 'promo';
export const PROMO_GRID_NAME = 'promo';
export const PROMO_MODAL_NAME = 'promo-modal';

export const PROMO_TYPE = {
  DEVALUATION_BONUS: 'DevaluationBonus',
  DEPOSIT_BONUS: 'DepositBonus',
  FIXED_BONUS: 'FixedBonus',
} as const;

export const PROMO_TYPES = {
  [PROMO_TYPE.DEPOSIT_BONUS]: 'Percent Deposit',
  [PROMO_TYPE.DEVALUATION_BONUS]: 'Devaluation',
  [PROMO_TYPE.FIXED_BONUS]: 'Fixed Bonus',
};

export const PROMO_TABS = {
  myAccount: 'MyAccount',
  email: 'Email',
};

export const PROMO_REGISTRIES = {
  ACTIVE_TAB: `${prefix}/active-tab`,
  ACTIVE_LANG: `${prefix}/active-lang`,
  LOADING: `${prefix}/loading`,
  IS_RESET_FORM: `${prefix}/reset-form`,
};

export const LIMIT_TYPE = 'limitType';
export const TOTAL_DEPOSIT_FROM = 'totalDepositFrom';
export const TOTAL_DEPOSIT_TO = 'totalDepositTo';
export const DEPOSIT_COUNT_FROM = 'depositCountFrom';
export const DEPOSIT_COUNT_TO = 'depositCountTo';
export const TOTAL_BONUS_AMOUNT = 'totalBonusAmount';
export const MAX_USAGE = 'maxUsage';

export const limitTypes = [
  { value: TOTAL_DEPOSIT_FROM, label: 'Total Deposit From' },
  { value: TOTAL_DEPOSIT_TO, label: 'Total Deposit To' },
  { value: DEPOSIT_COUNT_FROM, label: 'Deposits Count From' },
  { value: DEPOSIT_COUNT_TO, label: 'Deposits Count To' },
  { value: TOTAL_BONUS_AMOUNT, label: 'Total Bonus Amount' },
  { value: MAX_USAGE, label: 'Max Bonus Usage' },
];

export const limitTypesKeys = [
  TOTAL_DEPOSIT_FROM,
  TOTAL_DEPOSIT_TO,
  DEPOSIT_COUNT_FROM,
  DEPOSIT_COUNT_TO,
  TOTAL_BONUS_AMOUNT,
  MAX_USAGE,
];

export const TRANSACTION_SUB_TYPE_CREDIT_DICTIONARY_NAME =
  'creditTransactionSubTypes';
